import React from 'react';

const ClientSlider = () => {
    // Clients list with their logo image paths from the public folder
    const clients = [
        { name: "Airtel", img: "/airtel.png" },
        { name: "Jio", img: "/jio.png" },
        { name: "ACT Fibernet", img: "/act.png" },
        { name: "Birla Cables", img: "/birla.png" },
        { name: "Secure Meters", img: "/secure.png" },
        { name: "Manifold E-Connect", img: "/manifold.png" }
    ];

    // Seamless infinite loop ke liye array ko double kar rahe hain
    const duplicatedClients = [...clients, ...clients];

    return (
        <section className="py-16 bg-white overflow-hidden border-y border-gray-100">
            <div className="container mx-auto px-6 mb-8 text-center">
                <h2 className="text-sm md:text-base font-semibold text-gray-400 uppercase tracking-widest">
                    Trusted by Industry Leaders & Giants
                </h2>
            </div>

            {/* Slider Container with Marquee Animation */}
            <div className="relative w-full flex overflow-x-hidden group">
                <div className="flex gap-12 items-center whitespace-nowrap animate-marquee">
                    {duplicatedClients.map((client, index) => (
                        <div
                            key={index}
                            className="flex items-center justify-center min-w-[220px] h-24 px-6 bg-gray-50 border border-gray-200/80 rounded-xl shadow-sm hover:shadow-md hover:border-blue-500 transition-all duration-300 group/card"
                        >
                            <img
                                src={client.img}
                                alt={client.name}
                                className="max-h-12 w-auto object-contain transition-transform duration-300 group-hover/card:scale-110"
                            />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ClientSlider;